import React from 'react';
import PendingStockAdjustmentList from './PendingStockAdjustmentList';

const PendingStockAdjustment = () => (
  <React.Fragment>
    <div className="org-wrapper">
      <PendingStockAdjustmentList />
    </div>
  </React.Fragment>
);

export default PendingStockAdjustment;
